export enum ErrorMessage {
  SELF_AS_REFERENT_NOT_ALLOWED = 'You cannot add yourself as a referent',
}
